import { useMemo } from 'react';
import ArrowLeft from '../../icons/ArrowLeft';
import useMyRouter from '../../../lib/hooks/myRouter';

interface LoadMoreButtonProps {
  isComplete: boolean;
  nextPage: () => void;
  color?: string;
}

const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({
  isComplete,
  color,
  nextPage,
}) => {
  if (isComplete) {
    return <></>;
  }

  const { navToHash } = useMyRouter();

  const scrollToTop = () => {
    navToHash('results')
  }
  color = useMemo(() => color || 'primary', []);

  return (
    <div className="container block grid-cols-2 mx-auto md:grid">
      <button
        data-testid="load_more_button"
        onClick={nextPage}
        className={`hover:bg-white hover:text-${color} border-2 border-solid border-${color} bg-${color} w-[175px] mx-auto py-3 font-base font-bold rounded-full text-white my-6 col-span-2 col-start-1 row-start-1 block`}
      >
        Load More
      </button>
      <button onClick={scrollToTop} className="flex items-center col-start-2 row-start-1 p-4 ml-auto group text-primary-dark hover:text-profileButtons">
        <ArrowLeft className={'h-4 w-4 rotate-90 mr-2 stroke-primary-dark group-hover:stroke-profileButtons'} />
        Jump to top</button>
    </div>
  );
};

export default LoadMoreButton;
